import moment from 'moment';
import { defaultMaxYear, defaultMinYear } from './constants';

export const defaultMinDate = moment().subtract(defaultMinYear, 'years').toDate();
export const defaultMaxDate = moment().add(defaultMaxYear, 'years').toDate();
